import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaFacebookF, FaGoogle, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import './Login.css'; // Optional for extra styles
import illustration from '../assets/walk-illustration.png';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!email) errs.email = 'Email is required';
    if (!password) {
      errs.password = 'Password is required';
    } else {
      const passRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passRegex.test(password)) {
        errs.password = 'Password must be 8+ chars, include 1 capital, 1 number, 1 symbol';
      }
    }
    return errs;
  };

  const clearErrorOnValidInput = (field, value) => {
    if (errors[field]) {
      if (field === 'email' && value) {
        setErrors(prev => ({ ...prev, [field]: '' }));
      }

      if (field === 'password') {
        const passRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (passRegex.test(value)) {
          setErrors(prev => ({ ...prev, [field]: '' }));
        }
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length === 0) {
      navigate('/home');
    }
  };

  return (
    <Container fluid className="vh-100 d-flex align-items-center justify-content-center container">
      <Row className="w-75 w-md-75 rounded-4 overflow-hidden gx-0 gx-md-5">
        <Col md={6} style={{ padding: '6rem' }} className="d-flex flex-column justify-content-center">
          <h2 className="fw-bold lh-base mb-2 mt-5 signin-heading">Sign In</h2>
          <p>
            <strong className='fw-bold lh-base new-user'>New user?</strong>{' '}
            <a href="#" className="text-primary fw-bold lh-base new-user" style={{ textDecoration: "none" }}>
              Create an account
            </a>
          </p>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3 mt-3 fw-bold">
              <Form.Control
                type="email"
                placeholder="Username or email"
                value={email}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmail(val);
                  clearErrorOnValidInput('email', val);
                }}
                className="input-field fw-bold px-3 py-2 border border-2 rounded-0 border-dark ps-3"
                style={{ fontSize: '14px' }}
              />
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </Form.Group>

            <Form.Group className="mb-3 fw-bold">
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  const val = e.target.value;
                  setPassword(val);
                  clearErrorOnValidInput('password', val);
                }}
                className="input-field fw-bold px-3 py-2 border border-2 rounded-0 border-dark ps-3"
                style={{ fontSize: '14px' }}

              />
              {errors.password && <small className="text-danger">{errors.password}</small>}
            </Form.Group>

            <Form.Group className="mb-4 mt-4 d-flex align-items-center fw-bold custom-checkbox">
              <Form.Check
                type="checkbox"
                id="remember"
                label="Keep me signed in"
              />
            </Form.Group>

            <Button className="w-100 bg-dark border-0 rounded-0 input-field" style={{ fontSize: '14px' }}
              type="submit">
              Sign In
            </Button>
          </Form>

          <div className="text-center my-4 position-relative separator-container">
            <hr className="separator-line" />
            <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 separator-text">
              Or Sign In With
            </span>
          </div>


          <div className="d-flex justify-content-center gap-3">
            <span className="social-icon"><FaGoogle /></span>

            <span className="social-icon"><FaFacebookF /></span>
            <span className="social-icon"><FaLinkedinIn /></span>

            <span className="social-icon"><FaTwitter /></span>
          </div>
        </Col>

        <Col
          md={6}
          className="d-none d-md-flex justify-content-center align-items-center"
        >
          <img
            src={illustration}
            alt="login illustration"
            className="img-fluid"
            style={{ maxHeight: '500px', width: '100%', objectFit: 'contain' }}
          />
        </Col>


      </Row>
    </Container>
  );
};

export default Login;
